function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { ClickListener } from '@nt/dds-utils';
import cx from 'classnames';
import PortalPanel from '../Panel/PortalPanel';
import useSmartPanel from '../Panel/useSmartPanel';
import { useEscape } from '@nt/dds-utils';
import '@nt/dds-style/core/popover.css';
var spacer = 16;
var align = 'center';
var Popover = function Popover(_ref) {
  var className = _ref.className,
    children = _ref.children,
    _ref$childrenIsButton = _ref.childrenIsButton,
    childrenIsButton = _ref$childrenIsButton === void 0 ? false : _ref$childrenIsButton,
    content = _ref.content,
    id = _ref.id,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 'auto' : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'auto' : _ref$width,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'top' : _ref$direction,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 1000 : _ref$delay,
    _ref$hideCaret = _ref.hideCaret,
    hideCaret = _ref$hideCaret === void 0 ? false : _ref$hideCaret,
    portalContainerId = _ref.portalContainerId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    myPanelRef = _useState4[0],
    setPanelRef = _useState4[1];
  var buttonRef = useRef(null);
  var panelRef = useCallback(function (node) {
    if (node !== null) {
      setPanelRef(node);
    }
  }, []);
  var _useSmartPanel = useSmartPanel(buttonRef, myPanelRef, direction, align, spacer),
    panelRect = _useSmartPanel.panelRect,
    panelTopPos = _useSmartPanel.panelTopPos,
    panelLeftPos = _useSmartPanel.panelLeftPos,
    placement = _useSmartPanel.placement;
  var openWithDelay = function openWithDelay() {
    setTimeout(function () {
      setIsOpen(true);
    }, delay);
  };
  var close = function close() {
    if (isOpen) {
      setIsOpen(false);
    }
  };
  useEscape(close, isOpen);
  var parentClass = cx({
    'display-inlineblock': true,
    'position-relative': true
  });
  var popoverClass = cx({
    popover: true,
    'padding-lg': true
  }, className);
  var renderArrow = function renderArrow() {
    var topPos;
    var leftPos;
    var arrowClass = cx({
      'position-absolute': true,
      'zindex-1': true,
      'popover__arrow--bottom': placement === 'top',
      'popover__arrow--top': placement === 'bottom',
      'popover__arrow--left': placement === 'right',
      'popover__arrow--right': placement === 'left'
    });
    if (panelRect) {
      if (placement === 'top') {
        topPos = panelRect.height + panelTopPos - 1;
        leftPos = panelLeftPos + panelRect.width / 2;
      } else if (placement === 'bottom') {
        topPos = panelTopPos;
        leftPos = panelLeftPos + panelRect.width / 2;
      } else if (placement === 'left') {
        topPos = panelTopPos + panelRect.height / 2;
        leftPos = panelLeftPos + panelRect.width;
      } else {
        topPos = panelTopPos + panelRect.height / 2;
        leftPos = panelLeftPos;
      }
    }
    return /*#__PURE__*/React.createElement("div", {
      className: arrowClass,
      style: {
        top: topPos,
        left: leftPos
      }
    });
  };
  return /*#__PURE__*/React.createElement(ClickListener, {
    onClickOutside: close
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({
    ref: buttonRef,
    className: parentClass,
    onMouseEnter: openWithDelay,
    onMouseLeave: function onMouseLeave() {
      return setIsOpen(false);
    },
    onFocus: openWithDelay,
    onBlur: function onBlur() {
      return setIsOpen(false);
    },
    "aria-describedby": "".concat(id, "_Popover")
  }, !childrenIsButton && {
    role: 'button',
    tabIndex: 0
  }), children), isOpen && /*#__PURE__*/React.createElement(PortalPanel, {
    isOpen: isOpen,
    height: height,
    width: width,
    top: panelTopPos,
    left: panelLeftPos,
    ref: panelRef,
    className: popoverClass,
    id: "".concat(id, "_Popover"),
    role: "tooltip",
    portalContainerId: portalContainerId,
    sibling: !hideCaret && renderArrow()
  }, typeof content === 'function' ? content() : content)));
};
Popover.propTypes = {
  /** Content of the popover widget (accepts node or function) */
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /** Element that triggers the popover */
  children: PropTypes.node,
  /** Set this to true if you're already passing a button as children. Default is false */
  childrenIsButton: PropTypes.bool,
  /** Unique ID of the popover */
  id: PropTypes.string,
  /** Classname assigned to the popover */
  className: PropTypes.string,
  /** Height of the popover. Default is 'auto' based on popover content */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Width of the popover. Default is 'auto' based on popover content */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Direction of the popover to show up: ["top", "bottom", "left", or "right"] */
  direction: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  /** Add miliseconds delay before the popover shows up. Default is 1000 */
  delay: PropTypes.number,
  /** Display popover without the caret when set to true */
  hideCaret: PropTypes.bool,
  /** Id of the parent container for portal(if not provided the portal will be attached to document.body by default)  */
  portalContainerId: PropTypes.string
};
Popover.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Popover",
  "props": {
    "childrenIsButton": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set this to true if you're already passing a button as children. Default is false"
    },
    "height": {
      "defaultValue": {
        "value": "'auto'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Height of the popover. Default is 'auto' based on popover content"
    },
    "width": {
      "defaultValue": {
        "value": "'auto'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Width of the popover. Default is 'auto' based on popover content"
    },
    "direction": {
      "defaultValue": {
        "value": "'top'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'top'",
          "computed": false
        }, {
          "value": "'bottom'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }, {
          "value": "'right'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Direction of the popover to show up: [\"top\", \"bottom\", \"left\", or \"right\"]"
    },
    "delay": {
      "defaultValue": {
        "value": "1000",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Add miliseconds delay before the popover shows up. Default is 1000"
    },
    "hideCaret": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display popover without the caret when set to true"
    },
    "content": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": false,
      "description": "Content of the popover widget (accepts node or function)"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Element that triggers the popover"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Unique ID of the popover"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Classname assigned to the popover"
    },
    "portalContainerId": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Id of the parent container for portal(if not provided the portal will be attached to document.body by default)"
    }
  }
};
export default Popover;